import { render, staticRenderFns } from "./block2.vue?vue&type=template&id=74d1aebc&scoped=true&"
import script from "./block2.vue?vue&type=script&lang=js&"
export * from "./block2.vue?vue&type=script&lang=js&"
import style0 from "./block2.vue?vue&type=style&index=0&id=74d1aebc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d1aebc",
  null
  
)

export default component.exports